import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增应急预案
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyPlan/save',
        method: 'post',
        data
    })
}
//修改应急预案
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyPlan/update',
        method: 'post',
        data
    })
}
//查询应急预案列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyPlan/list',
        method: 'get',
        params
    })
}
//查询应急预案
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyPlan/detail?id=' + id,
        method: 'get',
    })
}
//删除应急预案
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyPlan/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}